import type React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { AnalyticsOverview } from "@/components/analytics/analytics-overview";
import { AnalyticsConversion } from "@/components/analytics/analytics-conversion";
import { AnalyticsFeatureComparison } from "@/components/analytics/analytics-feature-comparison";
import { AnalyticsTopProducts } from "@/components/analytics/analytics-top-products";

const AnalyticsPage: React.FC = () => {
  return (
    <>
      <main className="flex-1 space-y-6 p-2">
        <div className="space-y-2">
          <h2 className="text-3xl font-bold tracking-tight bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent">
            Analytics Dashboard
          </h2>
          <p className="text-muted-foreground">
            Comprehensive analytics across all features
          </p>
        </div>

        {/* Analytics Overview */}
        <AnalyticsOverview />

        {/* Conversion Funnel */}
        <Card>
          <CardHeader>
            <CardTitle>Conversion Funnel</CardTitle>
            <CardDescription>
              User journey from feature usage to purchase
            </CardDescription>
          </CardHeader>
          <CardContent>
            <AnalyticsConversion />
          </CardContent>
        </Card>

        <div className="grid gap-6 md:grid-cols-2">
          {/* Feature Comparison */}
          <Card>
            <CardHeader>
              <CardTitle>Feature Comparison</CardTitle>
              <CardDescription>
                Performance metrics across features
              </CardDescription>
            </CardHeader>
            <CardContent>
              <AnalyticsFeatureComparison />
            </CardContent>
          </Card>

          {/* Top Products */}
          <Card>
            <CardHeader>
              <CardTitle>Top Products</CardTitle>
              <CardDescription>
                Best performing products with AI features
              </CardDescription>
            </CardHeader>
            <CardContent>
              <AnalyticsTopProducts />
            </CardContent>
          </Card>
        </div>
      </main>
    </>
  );
};

export default AnalyticsPage;
